// @flow

import * as React from "react";
import axios from 'axios';
import {toast} from 'react-toastify';
import LoadingScreen from "./LoadingScreen.react";
import {showGenericErrorToast} from "../Utils";
import FrozenSubscriptionBanner from "./FrozenSubscriptionBanner.react";

class TeamPermissions extends React.Component {

  constructor() {
    super();
    this.state = {
      companyName: 'your company',
      members: [],
      loading: true,
      userSettings: null,
    };

    this.toggleAccess = this.toggleAccess.bind(this);
    this.toggleAdmin = this.toggleAdmin.bind(this);
  }

  componentDidMount() {
    this.loadMembers();
    // Only for the frozen-subscription banner; the page works without it.
    axios.get(window.SERVER_URL + '/get_settings').then((res) => {
      this.setState({userSettings: res.data.result});
    }).catch(() => {});
  }

  loadMembers() {
    axios.get(window.SERVER_URL + '/admin/team')
      .then((res) => {
        this.setState({
          companyName: res.data.result.company_name,
          members: res.data.result.members,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({loading: false});
        if (error.response && error.response.status === 403) {
          toast.error("You don't have permission to view this page");
          this.props.history.push('/dashboard');
        } else {
          toast.error("An error has occurred while loading the team");
        }
      });
  }

  toggleAccess(member) {
    axios.post(window.SERVER_URL + '/admin/team/access', {
      user_id: member.id,
      qb_connection_status: !member.qb_connection_status,
    }).then((res) => {
      this.setState({members: res.data.result.members});
      toast.success('Access updated');
    }).catch(() => showGenericErrorToast());
  }

  toggleAdmin(member) {
    axios.post(window.SERVER_URL + '/admin/team/role', {
      user_id: member.id,
      is_admin: !member.is_admin,
    }).then((res) => {
      this.setState({members: res.data.result.members});
      toast.success('Role updated');
    }).catch(() => showGenericErrorToast());
  }

  render(): React.Node {
    if (this.state.loading) {
      return <LoadingScreen />;
    }

    return (
      <div>
        <h2 style={{marginBottom: "24px"}}>Team Permissions</h2>
        {this.state.userSettings && this.state.userSettings.is_active === false ?
          <FrozenSubscriptionBanner userSettings={this.state.userSettings} style={{marginBottom: "24px"}} /> : null}
        <div className="app-card">
          <div className="app-card-title">Everyone connected to {this.state.companyName}</div>
          <div className="app-table-scroll">
          <table className="app-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Email</th>
                <th>Role</th>
                <th>Access</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {this.state.members.map((member) => (
                <tr key={member.id}>
                  <td>{member.first_name} {member.last_name}{member.is_self ? <span style={{color: "#8892a0"}}> (you)</span> : null}</td>
                  <td>{member.email_address}</td>
                  <td>
                    <span className={"app-badge " + (member.is_admin ? "app-badge-primary" : "app-badge-secondary")}>
                      {member.is_admin ? "Admin" : "Member"}
                    </span>
                  </td>
                  <td>
                    <span className={"app-badge " + (member.qb_connection_status ? "app-badge-success" : "app-badge-danger")}>
                      {member.qb_connection_status ? "Enabled" : "Disabled"}
                    </span>
                  </td>
                  <td>
                    {member.is_self ? "—" : (
                      <React.Fragment>
                        <button className={"btn btn-sm " + (member.qb_connection_status ? "btn-danger" : "btn-primary")} onClick={() => this.toggleAccess(member)}>
                          {member.qb_connection_status ? "Disable access" : "Enable access"}
                        </button>
                        &nbsp;
                        <button className="btn btn-sm btn-outline" onClick={() => this.toggleAdmin(member)}>
                          {member.is_admin ? "Remove admin" : "Make admin"}
                        </button>
                      </React.Fragment>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
      </div>
    );
  }
}

export default TeamPermissions;
